<div class="entities-loader">
    <div id="logo-animated"></div>
    <div class="entities-loader-paragraph">
        <span class="bold">{{'Te estamos redirigiendo a la banca online de' | translate}} {{bankName}}</span>
        <span class="light">{{counterText | translate}}</span>
    </div>
</div>
